export enum JobInterest {
  FULL_TIME = 'Full Time',
  INTERNSHIP = 'Internship',
  NONE = 'None',
}
export default JobInterest;
